let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7qc7K")).then(() => parcelRequire('lG2jM'));